<template>
  <div class="m-task clearfix"
    :mg-stat-show="`flag=43`" :mg-stat-lob="`typ=${data.taskId}&step=${data.status}&smod=score_task_list`"
    v-show="
      !['22', ...TEST_TASKS].includes(data.taskId) 
      || (data.taskId == 22 && ad) 
      || (TEST_TASKS.includes(data.taskId) && third)
      ">
    <span class="icon"><img :src="getIcon()" alt="" :class="iconName" /></span>

    <!-- <span class="icon" :style="{ backgroundImage: `url(${getIcon()})` }"></span> -->
    <div class="task-content">
      <h3 class="title">{{ data.title }} <span v-if="showTitleIcon" @click="$emit('titleIconClick', data)"
          class="i-icon"></span> </h3>
      <p class="info">
        {{ data.desc }}，完成{{ data.curStep }}/{{ data.maxStep }}
      </p>
    </div>

    <div class="operate">
      <a href="javascript:;" class="task-btn task-do" v-if="data.status === 0"
        @click="$emit('godo', data.taskId, data.url)">
        {{ btnTxt }}
      </a>
      <a class="task-btn task-getful" href="javascript:;" @click="$emit('goget', data.taskId)"
        v-else-if="data.status == 1">待领取</a>
      <span class="task-done" v-else-if="data.status === 2"> </span>
    </div>
  </div>
</template>

<script>
import TASK_MAP from './config'
import { TEST_TASKS } from '../../utils/mixin'
export default {
  data() {
    return {
      TEST_TASKS
    }
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    ad: {
      type: Boolean,
      default: null,
    },
    third: {
      type: Boolean,
      default: null
    }
  },
  mounted() {
    console.log(this.data);
  },
  computed: {
    showTitleIcon(){
      return TASK_MAP[this.data.taskId].showTitleIcon
    },
    iconName() {
      return TASK_MAP[this.data.taskId].icon
    },
    btnTxt() {
      return TASK_MAP[this.data.taskId].btn
    },
  },
  methods: {
    getIcon() {
      if (!this.iconName) return ''
      return require(`../../assets/task-icon/${this.iconName}.png`)
    },
  },
}
</script>

<style lang="less">
.m-task {
  .icon {
    .wh(70px, 70px);
    .flexCenter();
    float: left;
    margin-right: 10px;

    img {
      .wh(70px, 70px);
      object-fit: cover;

      &.icon-exploring {
        .wh(52px, 54px);
      }
    }
  }

  .task-content {
    float: left;
    .title {
      .sizeColor(28px, #666);
      display: flex;
      align-items: center;
    }
    .i-icon{
      margin-left: 10px;
      width: 25px;
      height: 25px;
      background-image: url('../../assets/icon-rules.png');
      background-size: 100% 100%;
    }

    .info {
      .sizeColor(24px, #999);
      margin-top: 6px;
      line-height: 33px;

      // span {
      //   margin-left: 4px;
      //   font-size: 28px;
      //   font-weight: bold;
      // }
    }
  }
  .operate {
    float: right;
    margin-right: 40px;
    margin-top: 2px;
  }
  .task-btn {
    .wh(140px, 58px);
    .sizeColor(26px, #fff);
    .center(58px);
    display: block;
    border-radius: 58px;
    font-weight: bold;

    &.task-do {
      background: url('../../assets/icon-task-bg.png') no-repeat;
      background-size: 100% 100%;
      color: #ff5f00;
    }

    &.task-getful {
      background: -webkit-gradient(
        linear,
        left top,
        right bottom,
        from(#ff913e),
        to(#ff6f5a)
      );
      color: #fff;
    }
  }

  .task-done {
    .wh(98px, 86px);
    display: block;
    background: url('../../assets/task-icon/icon-done.png') no-repeat;
    background-size: 100% 100%;
    margin-right: 20px;
  }
}
</style>
